module.exports = __webpack_public_path__ + "img/汪寿阳.eccd8708.png";